import { Component, DestroyRef, inject, signal } from '@angular/core';
import { HeroComponent } from './hero/hero.component';
import { LocationComponent } from './location/location.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { SzebitInNumbersComponent } from './szebit-in-numbers/szebit-in-numbers.component';
import { WhatIsSzebitComponent } from './what-is-szebit/what-is-szebit.component';
import { PartnersComponent } from './partners/partners.component';
import { GalleriesComponent } from './galleries/galleries.component';
import { MapComponent } from './map/map.component';
import { ScrollToFragmentDirective } from '../../directives/scroll-to-fragment.directive';
import { ProgramsComponent } from './programs/programs.component';
import { ShowOnDesktopDirective } from '../../core/device/show-on-desktop.directive';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { AuditorsComponent } from './auditors/auditors.component';

@Component({
  selector: 'app-home',
  imports: [
    HeroComponent,
    LocationComponent,
    ComingSoonComponent,
    SzebitInNumbersComponent,
    WhatIsSzebitComponent,
    ProgramsComponent,
    PartnersComponent,
    GalleriesComponent,
    AuditorsComponent,
    MapComponent,
    ShowOnDesktopDirective,
    MatIcon,
    MatIconButton,
  ],
  template: `@if (showMobileInstallNotification()) {
      <div *appShowOnDesktop class="relative bg-[#585858]"
        ><button
          class="!absolute top-1 right-1 text-[silver]"
          mat-icon-button
          type="button"
          (click)="showMobileInstallNotification.set(false)"
        >
          <!-- eslint-disable-next-line pct-custom-ng-rules/no-mat-icon-svg-icon -->
          <mat-icon svgIcon="pct-mdi-close" /></button
        ><p class="text-center text-[#f58e20] p-4"
          ><b>Kedves Felhasználó!</b><br />
          Az alkalmazásunk mostantól mobilon is elérhető. Kérjük, nyissa meg a
          <span class="text-white bold">https://szebit.hu</span> weboldalt telefonján és kövesse a
          telepítési utasításokat a gördülékeny használathoz.</p
        >
      </div>
    }
    <app-hero />
    <app-location />
    <app-coming-soon />
    <app-szebit-in-numbers />
    <app-what-is-szebit />
    <app-auditors />
    <app-programs />
    <app-partners />
    <app-galleries />
    <app-map />`,
  hostDirectives: [ScrollToFragmentDirective],
  host: {
    class: 'full-page',
  },
})
export default class HomeComponent {
  protected readonly showMobileInstallNotification = signal(true);

  constructor() {
    const timeoutRef = setTimeout(() => this.showMobileInstallNotification.set(false), 30 * 1000);
    inject(DestroyRef).onDestroy(() => {
      clearTimeout(timeoutRef);
    });
  }
}
